module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-ramen@2x-3adc9c7c4eeae6ffc7e97d882f148873.png";